import Emittery from 'emittery';

const emitter = new Emittery({
  debug: { enabled: process.env.NODE_ENV !== 'production', name: 'gotedo_app_event_bus' },
});

export { emitter };

export default {
  install(Vue) {
    Vue.prototype.$emitter = emitter;
  },
};
